import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const FilterIcon: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper onClick={onClick} divClassName={divClassName}>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M3.00067 1.99994H13.0007L7.99067 8.29994L3.00067 1.99994ZM0.250666 1.60994C2.27067 4.19994 6.00067 8.99994 6.00067 8.99994V14.9999C6.00067 15.5499 6.45067 15.9999 7.00067 15.9999H9.00067C9.55067 15.9999 10.0007 15.5499 10.0007 14.9999V8.99994C10.0007 8.99994 13.7207 4.19994 15.7407 1.60994C16.2507 0.949939 15.7807 -6.10352e-05 14.9507 -6.10352e-05H1.04067C0.210666 -6.10352e-05 -0.259334 0.949939 0.250666 1.60994Z" fill="#434649" fillOpacity="0.85" />
    </svg>
  </SvgWrapper>
);